<template>
  <!-- <nav v-if="isDevEnvironment">
        <router-link to="/">Home</router-link> |
        <router-link to="/requests">Requests</router-link> |
        <a v-if="authState && authState.isAuthenticated" href="#" @click.prevent="logout">Logout</a>
        <a v-else href="#" @click.prevent="login">Login</a>
      </nav> -->
  <router-view />

  <!-- <details>
    <summary>Debug</summary><code>{{ authState }}</code>
  </details> -->
</template>

<script>

export default {
  name: 'App',
  methods: {
    async login() {
      await this.$auth.signInWithRedirect()
    },
    async logout() {
      await this.$auth.signOut()
    }
  },
  computed: {
    isDevEnvironment() {
      return process.env.NODE_ENV !== 'production';
    },
  }
}
</script>

<style>
:root {
  --primary-color: #2495C6;
  --secondary-color: #8CC7ED;
  --text-color: #43474F;
  --background: #fcfcfc;
  --accent: #E2972F;
  --light-primary: #8CC7ED;
  --negative-accent: #8CC7ED;
}

body {
  padding: 10px;
  font-family: 'Roboto', sans-serif;
  color: var(--text-color);
  line-height: 1.6;
  background-color: var(--background);
}

.main-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 30px 15px;
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(67, 71, 79, 0.2);
  background-color: #fff;
  min-height: 309px; /* Golden ratio */
}

.main-box p {
  font-size: 18px;
}

.main-box .request-item {
  justify-content: center;
  align-items: center;
  width: 450px;
  margin-bottom: 20px;
}

.request-item{
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  border-style: solid;
  border-width: 2px;
  border-color: var(--primary-color);
}

.main-box-full{
  width: 100%;
}

button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.loader {
  border: 5px solid #f3f3f3;
  border-top: 5px solid var(--primary-color);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

button {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  height: 3rem;
  letter-spacing: 0.0892857143em;
  color: #ffffff;
  background-color: var(--primary-color);
  border: none;
  padding: 6px 16px;
  font-size: 1.2rem;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  vertical-align: middle;
  user-select: none;
  outline: none;
  cursor: pointer;
  z-index: 0;
  transition: background-color .3s cubic-bezier(.4, 0, .2, 1), box-shadow .2s cubic-bezier(.4, 0, .2, 1);
  justify-content: center;
  text-decoration: none;
  margin: 7px;
}

button:hover {
  background-color: var(--light-primary);
}

button:active {
  background-color: var(--accent);
}


</style>
